/*External dependencies */
import update from 'immutability-helper';

/* Local dependencies */
import { GetDeviceActions, GetDeviceActionTypes } from './action';
import { Device } from '../../createDevice/redux/action';
import { initialApproveDeviceState } from '../../approveDevice/redux/reducer';

export interface GetDeviceState {
  isGetDeviceModalOpen: boolean;
  loading: boolean;
  error: string;
  device: Device;
}

export const initialGetDeviceState: GetDeviceState = {
  isGetDeviceModalOpen: false,
  loading: false,
  error: '',
  device: {
    id: '',
    __typename: '',
    approvalsCount: 0,
    address: '',
    location: {
      lat: 0,
      lon: 0,
    },
    notes: '',
    organization: '',
    registrationDate: '',
    status: '',
    user: {
      id: '',
    },
  },
};

export default function getDeviceReducer(state = initialGetDeviceState, action: GetDeviceActions) {
  switch (action.type) {
    case GetDeviceActionTypes.OPEN_GET_DEVICE_MODAL:
      return update(state, {
        isGetDeviceModalOpen: { $set: true },
        loading: { $set: true },
        device: { $set: null },
      });
    case GetDeviceActionTypes.CLOSE_GET_DEVICE_MODAL:
      return update(state, {
        isGetDeviceModalOpen: { $set: false },
        device: { $set: null },
      });
    case GetDeviceActionTypes.GET_DEVICE_REQUEST:
      return update(state, {
        loading: { $set: true },
      });
    case GetDeviceActionTypes.GET_DEVICE_SUCCEEDED:
      return update(state, {
        loading: { $set: false },
        device: { $set: action.device },
      });
    case GetDeviceActionTypes.GET_DEVICE_FAILED:
      return update(state, {
        error: { $set: action.error },
        device: { $set: null },
      });

    default:
      return state;
  }
}
